
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 21A10.5 10.5 0 1121 10.5 10.5 10.5 0 0110.5 21zm0-20a9.5 9.5 0 109.5 9.5A9.5 9.5 0 0010.5 1zm13 22.5l-6-6"}}),_c('path',{attrs:{"d":"M23.5 24a.5.5 0 01-.4-.1l-5.9-6a.5.5 0 01.7-.7l6 6a.5.5 0 01-.4.8z"}})])
          )
        }
      }
    